<template>
   <Teleport v-if="visible" to="body">
      <div
         data-name="alert-backdrop"
         class="px-(--dashboard-page-padding) starting:bg-transparent fixed inset-0 z-[999] flex items-center justify-center bg-black/30 px-4 transition-all"
      >
         <div
            ref="target"
            data-name="alert-content"
            class="__shadow starting:translate-y-6 starting:scale-95 starting:opacity-0 flex w-full max-w-[450px] flex-col gap-5 rounded-[22px] bg-white p-[22px] transition-all duration-500"
         >
            <div class="flex flex-col gap-1.5">
               <div class="flex items-center gap-2">
                  <Icon
                     v-if="type === 'confirm'"
                     :name="statusIcon"
                     class="size-6"
                     :class="statusColorClass"
                  />
                  <Icon v-if="type === 'loading'" name="spinner" class="size-6 animate-spin" />

                  <p class="h-l">
                     {{ title }}
                  </p>
               </div>
               <p v-if="description" class="p-m text-grey">
                  {{ description }}
               </p>
            </div>

            <div v-if="type === 'confirm'" class="flex gap-2">
               <Button grow variant="light-grey" @click="$emit('cancel')">
                  {{ discardLabel }}
               </Button>
               <Button grow @click="$emit('confirm')">
                  {{ confirmLabel }}
               </Button>
            </div>
         </div>
      </div>
   </Teleport>
</template>

<script lang="ts" setup>
import { onClickOutside } from '@vueuse/core'
import type { Status } from '@xleddyl/types'
import { computed, ref } from 'vue'

type Props = {
   title: string
   description?: string
   type?: 'confirm' | 'loading'
   status?: Status
   visible?: boolean
   confirmLabel?: string
   discardLabel?: string
}

type Emits = {
   (e: 'confirm'): void
   (e: 'cancel'): void
}

const props = withDefaults(defineProps<Props>(), {
   visible: true,
   type: 'confirm',
   confirmLabel: '',
   discardLabel: '',
})
const emit = defineEmits<Emits>()
const target = ref<HTMLElement>()

const statusIcon = computed(() =>
   props.status ? getStatusProps(props.status).icon : 'information-circle'
)
const statusColorClass = computed(() =>
   props.status ? getStatusProps(props.status).colorClass : ''
)

onClickOutside(target, () => {
   if (props.type === 'confirm') {
      emit('cancel')
   }
})
</script>
